import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, useLocation, Outlet } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { CartProvider } from "@/lib/cart";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import WhatsAppFab from "@/components/WhatsAppFab";
import PromoPopup from "@/components/PromoPopup";
import CartDrawer from "@/components/CartDrawer";
import AuthCallback from "@/components/AuthCallback";
import { Toaster } from "sonner";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import OrderResult from "@/pages/OrderResult";
import Auth from "@/pages/Auth";
import Account from "@/pages/Account";
import MyOrders from "@/pages/MyOrders";
import TrackOrder from "@/pages/TrackOrder";
import StaticPage from "@/pages/StaticPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminResetPassword from "@/pages/AdminResetPassword";
import AdminDashboard from "@/pages/AdminDashboard";

function StorefrontLayout() {
  return (
    <>
      <Nav />
      <main className="min-h-[60vh]"><Outlet /></main>
      <Footer />
      <WhatsAppFab />
      <PromoPopup />
      <CartDrawer />
    </>
  );
}

function AdminLayout() {
  return (
    <div className="min-h-screen bg-cream-100">
      <div className="bg-ink-900 text-cream-100 py-3 px-6 lg:px-10 flex items-center justify-between">
        <img
          src="https://customer-assets-cm19k8pv.emergentagent.net/job_glow-essentials-49/artifacts/rvxnzwby_Immuski%20Logo%20transparent%20White.webp"
          alt="IMMUSKI"
          style={{ height: 26 }}
        />
        <div className="eyebrow text-gold-400">Admin console</div>
      </div>
      <Outlet />
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  // Handle OAuth callback anywhere it lands (session_id in URL fragment)
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <>
      <ScrollToTop />
      <Routes>
      <Route element={<StorefrontLayout />}>
        <Route index element={<Home />} />
        <Route path="shop" element={<Shop />} />
        <Route path="product/:slug" element={<ProductDetail />} />
        <Route path="cart" element={<Cart />} />
        <Route path="checkout" element={<Checkout />} />
        <Route path="order-success" element={<OrderSuccess />} />
        <Route path="order-result" element={<OrderResult />} />
        <Route path="auth" element={<Auth />} />
        <Route path="auth/callback" element={<AuthCallback />} />
        <Route path="account" element={<Account />} />
        <Route path="account/orders" element={<MyOrders />} />
        <Route path="track" element={<TrackOrder />} />
        <Route path="about" element={<StaticPage pageKey="about" />} />
        <Route path="contact" element={<StaticPage pageKey="contact" />} />
        <Route path="dermatologists" element={<StaticPage pageKey="derm" />} />
        <Route path="returns" element={<StaticPage pageKey="returns" />} />
      </Route>
      <Route element={<AdminLayout />}>
        <Route path="admin/login" element={<AdminLogin />} />
        <Route path="admin/reset-password" element={<AdminResetPassword />} />
        <Route path="admin" element={<AdminDashboard />} />
      </Route>
    </Routes>
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <AppRouter />
            <Toaster position="top-center" toastOptions={{
              style: { background: "#0A0A0A", color: "#ffffff", border: "1px solid #B8945A", borderRadius: 0, fontFamily: '"Futura", "Jost", "Century Gothic", sans-serif' },
              className: "font-sans",
            }} />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
